// TODO: get rid of this file
import Vue from 'vue'
import { WELL_STATUS } from '../factory/DataModel'
import LocalStorage from '../services/LocalStorage'
import UIUtils from '../utils/UIUtils'
import BackendProvider from '../services/BackendProvider'

export default class MainController {
    handleSignOut() {
        Vue.$store.dispatch('common/resetSession')
        Vue.$store.dispatch('navigation/resetSession')
        Vue.$store.dispatch('navigation2d/resetSession')
        Vue.$store.dispatch('timelapse/resetSession')
        Vue.$store.dispatch('twoD/resetSession')
        Vue.$store.dispatch('video/resetSession')

        LocalStorage.resetCache()
    }

    signOut() {
        this.handleSignOut()
        BackendProvider.signOut()
    }

    async share(shareEmail, shareMessage, shareUrl) {
        Vue.$log.actionEvent('share')

        UIUtils.showLoadingMask()
        await BackendProvider.share(shareEmail, shareMessage, shareUrl)
        UIUtils.hideLoadingMask()

        UIUtils.toast(Vue.$store.getters['locale/translate']('message_sent'))
    }

    selectWell(well) {
        UIUtils.showLoadingMask()

        Vue.$store.dispatch('navigation/navigateToWell', {
            patientId: well.patientId,
            treatmentId: well.treatmentId,
            wellId: well._id
        })
    }

    async changeWellStatus(well, statusKey) {
        const status = WELL_STATUS[statusKey]
        const statusToSet = well.status === status ? null : status

        Vue.$log.actionEvent('change_well_status', statusToSet)

        UIUtils.showLoadingMask()

        await BackendProvider.updateWell(well._id, { status: statusToSet })

        // patch for three sources of truth for wells: selected-well, treatment, slide
        Vue.set(well, 'status', statusToSet)

        const slideWell = Vue.$store.getters['timelapse/getSlideWell'](well._id)
        if (slideWell) {
            Vue.set(slideWell, 'status', statusToSet)
        }

        const treatmentWell = Vue.$store.getters['timelapse/getTreatmentWell'](well._id)
        if (treatmentWell) {
            Vue.set(treatmentWell, 'status', statusToSet)
        }

        UIUtils.hideLoadingMask()
    }

    async updateWellsFertMethod(wells, fertMethod) {
        const wellIds = wells.map(well => well._id)

        if (wellIds.length) {
            UIUtils.showLoadingMask()
            await BackendProvider.updateWellsFertMethod({
                ids: wellIds,
                method: fertMethod
            })

            wells.forEach(well => {
                const newInsemination = { ...well.insemination, method: fertMethod }

                Vue.set(well, 'insemination', newInsemination)

                const treatmentWell = Vue.$store.getters['timelapse/getTreatmentWell'](well._id)

                if (treatmentWell) {
                    Vue.set(treatmentWell, 'insemination', newInsemination)
                }
            })
            UIUtils.hideLoadingMask()
        }
    }

    async updateWellsFertApproval(wells) {
        const wellIds = wells.map(well => well._id)

        if (wellIds.length) {
            UIUtils.showLoadingMask()
            await BackendProvider.updateWellsFertMethod({ ids: wellIds, isApproved: true })

            wells.forEach(well => {
                const newInsemination = { ...well.insemination, isApproved: true }

                Vue.set(well, 'insemination', newInsemination)

                const treatmentWell = Vue.$store.getters['timelapse/getTreatmentWell'](well._id)

                if (treatmentWell) {
                    Vue.set(treatmentWell, 'insemination', newInsemination)
                }
            })
            UIUtils.hideLoadingMask()
        }
    }
}
